import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify"; // ✅ import toast
import "react-toastify/dist/ReactToastify.css";
import "../components/CategoryEdit.css";

const CategoryEdit = () => {
  const { category_id } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [categoryDetail, setCategoryDetail] = useState("");
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  // ✅ Fetch category details
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const token = localStorage.getItem('session_token');
        const url = `https://newerp.awasthivitality.com/api/category/edit/${category_id}${token ? `?token=${encodeURIComponent(token)}` : ''}`;
        const response = await fetch(url, { headers: { ...(token ? { 'Authorization': `Bearer ${token}`, 'X-Session-Token': token } : {}) }});
        const result = await response.json();
        console.log("Fetched Category:", result);

        const categoryData = result.data || result;

        if (response.ok && categoryData) {
          setName(categoryData.name || "");
          setCategoryDetail(categoryData.category_detail || "");
        } else {
          toast.error("Failed to fetch category data.");
        }
      } catch (error) {
        console.error("Error fetching category:", error);
        toast.error("Error loading category data.");
      } finally {
        setLoading(false);
      }
    };

    if (category_id) fetchCategory();
  }, [category_id]);

  // ✅ Update category
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.warn("Please enter a category name.");
      return;
    }

    setUpdating(true);

    try {
      const token = localStorage.getItem('session_token');
      const url = `https://newerp.awasthivitality.com/api/category/update/${category_id}${token ? `?token=${encodeURIComponent(token)}` : ''}`;
      const response = await fetch(url, {
        method: "PUT",
        headers: { 
          "Content-Type": "application/json",
          ...(token ? { 'Authorization': `Bearer ${token}`, 'X-Session-Token': token } : {})
        },
        body: JSON.stringify({
          name,
          category_detail: categoryDetail,
        }),
      });

      const result = await response.json();
      console.log("Update Response:", result);

      if (response.ok) {
        toast.success(" Category updated successfully!");
        setTimeout(() => navigate("/Category"), 2000); // redirect after 2s
      } else {
        toast.error("❌ Failed to update category.");
      }
    } catch (error) {
      console.error("Error updating category:", error);
      toast.error("Something went wrong while updating.");
    } finally {
      setUpdating(false);
    }
  };

  if (loading) {
    return <div className="category-edit-container">Loading...</div>;
  }

  return (
    <div className="category-edit-container">
      <div className="category-edit-box">
        <div className="category-edit-header">
          <h5 className="category-edit-title">Edit Category</h5>
          <div className="category-edit-menu">✎</div>
        </div>

        <form className="category-edit-content" onSubmit={handleUpdate}>
          <div className="category-edit-field">
            <label htmlFor="editCategoryName">Category Name</label>
            <input
              type="text"
              id="editCategoryName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter category name"
            />
          </div>

          <div className="category-edit-field">
            <label htmlFor="editCategoryDetail">Category Details</label>
            <textarea
              id="editCategoryDetail"
              value={categoryDetail}
              onChange={(e) => setCategoryDetail(e.target.value)}
              placeholder="Enter category details"
              rows="4"
            />
          </div>

          <button type="submit" className="category-edit-submit" disabled={updating}>
            {updating ? "Updating..." : "Update Category"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CategoryEdit;
